module.exports = Object.freeze({
    CREATE_POLL: 'CREATE_POLL',
    FORCE_TO_LOBBY: 'FORCE_TO_LOBBY',
    BROADCAST_MESSAGE: 'BROADCAST_MESSAGE',
    NEED_HELP: 'NEED_HELP',
    WHITEBOARD: 'WHITEBOARD',
    TIMER: 'TIMER',
    LAST_N: 'LAST_N',
    CREATE_BREAKOUTS: 'CREATE_BREAKOUTS',
    BREAKOUTS_VISIBILITY: 'BREAKOUTS_VISIBILITY',
    ADD_PASSWORD_LOCK: 'ADD_PASSWORD_LOCK',
    LOCK_ROOM: 'LOCK_ROOM',
    UNLOCK_ROOMS: 'UNLOCK_ROOMS',
    SEE_PARTICIPANTS_NAMES: 'SEE_PARTICIPANTS_NAMES',
    CAN_RECORD_VIDEO: 'CAN_RECORD_VIDEO'
})